import GDPR from "./components/GDPR";
import Navbar from "./components/Navbar";
import NavbarDropdown from "./components/NavbarDropdown";
import Recaptcha from "./components/Recaptcha";
import Bootstrap from "./components/Bootstrap";

window.addEventListener('load', function () {

    Bootstrap.run() /** We add Boostrap globally */

    GDPR.run();
    Navbar.run();
    NavbarDropdown.run();
    Recaptcha.run()

});

console.log("Powered by Softedge Studio - softedge.be");

